import { EllipsisOutlined, SortAscendingOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu, Typography } from 'antd';
import { getTaskSearchesStore } from 'core/modules/tasks/task-search.store';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TasksListSearchesOrderModal } from 'src/components/Tasks/List/SearchesOrderModal';
import { classes } from 'src/utils/classes';
import useWindowSize from 'src/utils/window';
import styled from 'styled-components';
/** Bar that shows the saved searches */

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TasksListSavedSearchesBar = function TasksListSavedSearchesBar() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _getTaskSearchesStore = getTaskSearchesStore(),
      searches = _getTaskSearchesStore.searches,
      currentSearchId = _getTaskSearchesStore.currentSearchId,
      setCurrentSearchId = _getTaskSearchesStore.setCurrentSearchId;

  var _useWindowSize = useWindowSize(),
      width = _useWindowSize.width;

  var _useState = useState(),
      invisibleAfter = _useState[0],
      setInvisibleAfter = _useState[1];

  var _useState2 = useState(false),
      showOrderModal = _useState2[0],
      setShowOrderModal = _useState2[1];

  var invisibleItems = useMemo(function () {
    return invisibleAfter ? searches.slice(invisibleAfter, searches.length) : [];
  }, [searches, invisibleAfter]);
  var isInvisibleSelected = useMemo(function () {
    return invisibleItems.some(function (item) {
      return item.id === currentSearchId;
    });
  }, [invisibleItems, currentSearchId]);
  useEffect(function () {
    var container = document.getElementById('search-bar-filters');

    if (!container) {
      return;
    }

    for (var i = 0; i < container.children.length; i++) {
      var child = container.children[i];

      if (child.offsetTop > 70) {
        return setInvisibleAfter(i);
      }
    }

    setInvisibleAfter(undefined);
  }, [width, searches]);
  return useMemo(function () {
    return /*#__PURE__*/_jsxs(Container, {
      className: classes({
        empty: searches.length === 0
      }),
      children: [searches.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Typography.Title, {
          level: 5,
          children: t('tasks.filters')
        }), /*#__PURE__*/_jsx("div", {
          id: "search-bar-filters",
          className: "filters",
          children: searches.map(function (search) {
            return /*#__PURE__*/_jsx(Button, {
              type: search.id === currentSearchId ? 'primary' : 'link',
              value: search.id,
              onClick: function onClick() {
                return setCurrentSearchId(currentSearchId === search.id ? undefined : search.id);
              },
              children: search.title
            }, search.id);
          })
        })]
      }), searches.length > 1 && /*#__PURE__*/_jsx(Dropdown, {
        overlay: /*#__PURE__*/_jsxs(Menu, {
          selectedKeys: [currentSearchId],
          children: [invisibleItems.map(function (item) {
            return /*#__PURE__*/_jsx(Menu.Item, {
              onClick: function onClick() {
                return setCurrentSearchId(currentSearchId === item.id ? undefined : item.id);
              },
              children: item.title
            }, item.id);
          }), invisibleItems.length > 0 && /*#__PURE__*/_jsx(Menu.Divider, {}), /*#__PURE__*/_jsx(Menu.Item, {
            icon: /*#__PURE__*/_jsx(SortAscendingOutlined, {}),
            onClick: function onClick() {
              return setShowOrderModal(true);
            },
            children: t('tasksList.changeOrder')
          })]
        }),
        children: /*#__PURE__*/_jsx(Button, {
          type: isInvisibleSelected ? 'primary' : 'text',
          children: /*#__PURE__*/_jsx(EllipsisOutlined, {})
        })
      }), /*#__PURE__*/_jsx(TasksListSearchesOrderModal, {
        visible: showOrderModal,
        onClose: function onClose() {
          return setShowOrderModal(false);
        }
      })]
    });
  }, [searches, currentSearchId, invisibleAfter, showOrderModal]);
}; // Styles

var Container = styled.div.withConfig({
  displayName: "SavedSearchesBar__Container",
  componentId: "sc-vg1300-0"
})(["padding:12px 24px;display:flex;flex-direction:row;align-items:center;.ant-typography{text-transform:uppercase;margin:0 24px 0 0;}.filters{max-width:100%;overflow:hidden;margin-right:24px;flex-wrap:wrap;height:32px;}&.empty{padding-bottom:0;}"]);